import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export default (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      width: '100%',
    },
    header: {
      paddingHorizontal: theme.spacing.xl,
      paddingTop: theme.spacing.sm,
      paddingBottom: theme.spacing.md,
    },
    navigationContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: theme.spacing.lg,
    },
    backContainer: {
      width: 30,
      alignItems: 'flex-start',
    },
    skipContainer: {
      width: 'auto',
      alignItems: 'flex-end',
      marginLeft: theme.spacing.md,
      marginRight: theme.spacing.md,
    },
    divider: {
      height: 1,
      backgroundColor: theme.colors.grey,
      marginTop: theme.spacing.md,
      marginHorizontal: -theme.spacing.xl,
    },
  })
